import React from "react";
import { Form, Input, Button } from "antd";

function DynamicList({ name, label, placeholder }) {
  return (
    <Form.Item label={label}>
      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field) => (
              <div
                key={field.key}
                style={{ display: "flex", gap: 8, marginBottom: 8 }}
              >
                <Form.Item {...field} noStyle>
                  <Input placeholder={placeholder} style={{ flex: 1 }} />
                </Form.Item>
                <Button danger onClick={() => remove(field.name)}>
                  —
                </Button>
              </div>
            ))}
            <Button type="dashed" onClick={() => add()} block>
              + Нэмэх
            </Button>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
}

export default function OverviewSection() {
  return (
    <>
      <DynamicList
        name="keyFacts"
        label="Үндсэн мэдээлэл"
        placeholder="Жишээ: Жилийн 0% хүү"
      />
      <DynamicList
        name="pros"
        label="Давуу тал"
        placeholder="Жишээ: Cashback 2%"
      />
      <DynamicList
        name="cons"
        label="Сул тал"
        placeholder="Жишээ: Гадаад гүйлгээнд нэмэлт шимтгэл"
      />
      <DynamicList
        name="requirements"
        label="Шаардлага"
        placeholder="Жишээ: 18+ нас"
      />
    </>
  );
}
